var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ex-button",class:_vm.isActive ? 'ex-button-primary': 'ex-button-primary-inverse',attrs:{"name":_vm.name},on:{"click":function($event){return _vm.setChoiceOption()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }